module.exports = __webpack_public_path__ + "static/media/link_deleat_hover.7901a016.svg";